// Utilidades de imagen para el gestor de colecciones (cliente).

export interface PixelCrop {
  x: number;
  y: number;
  width: number;
  height: number;
}

// Slug kebab-case desde un título (quita acentos, espacios, símbolos).
export function slugify(input: string): string {
  return input
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
}

// Variante para editar el slug tecleando: sanea igual que `slugify`
// pero **conserva un guion final** en curso, para que se pueda escribir
// `rock-` y seguir con `rock-clasico` (el `slugify` completo borra el
// guion final en cada tecla y hace imposible añadirlo). El guion final
// residual lo limpia el `slugify` completo al salir del campo / enviar.
export function slugifyInput(input: string): string {
  return input
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/-{2,}/g, '-')
    .replace(/^-+/, '');
}

function loadImage(src: string): Promise<HTMLImageElement> {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => resolve(img);
    img.onerror = reject;
    img.src = src;
  });
}

// Genera un object URL con la región recortada, solo para previsualizar
// en el admin (el recorte real lo hace la API con sharp).
export async function getCroppedPreviewUrl(
  src: string,
  crop: PixelCrop,
): Promise<string> {
  const img = await loadImage(src);
  const canvas = document.createElement('canvas');
  canvas.width = Math.max(1, Math.round(crop.width));
  canvas.height = Math.max(1, Math.round(crop.height));
  const ctx = canvas.getContext('2d');
  if (!ctx) throw new Error('No 2d context');
  ctx.drawImage(
    img,
    crop.x,
    crop.y,
    crop.width,
    crop.height,
    0,
    0,
    canvas.width,
    canvas.height,
  );
  return new Promise((resolve, reject) => {
    canvas.toBlob(
      (blob) => (blob ? resolve(URL.createObjectURL(blob)) : reject(new Error('toBlob failed'))),
      'image/webp',
      0.8,
    );
  });
}
